import type { GeoLocation } from '@smg-real-estate/geo-libs';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';

import {
  evaluateNewSrpIndexation,
  type NewSrpIndexationResult,
} from '@/helpers/SEO/newSrpIndexation';

/** Reactive SEO indexation for Agency and Agent SRP pages. */
export function useNewSrpIndexation({
  locations,
  pageQuery,
  totalCount,
}: {
  locations: MaybeRefOrGetter<GeoLocation[] | null | undefined>;
  pageQuery: MaybeRefOrGetter<unknown>;
  totalCount: MaybeRefOrGetter<number>;
}) {
  const evaluation = computed((): NewSrpIndexationResult =>
    evaluateNewSrpIndexation({
      locations: toValue(locations),
      pageQuery: toValue(pageQuery),
      totalCount: toValue(totalCount),
    }),
  );

  const robotsMeta = computed(() => {
    const content = evaluation.value.robotsContent;
    if (!content) {
      return [];
    }

    return [
      { name: 'robots', content },
      { 'http-equiv': 'x-robots-tag', content },
    ];
  });

  return {
    evaluation,
    robotsMeta,
    isIndexable: computed(() => evaluation.value.isIndexable),
    isIndexableForJsonLd: computed(() => evaluation.value.isIndexableForJsonLd),
    fetchPage: computed(() => evaluation.value.fetchPage),
  };
}
